(() => {
  const bindFilms = (root = document) => {
    root.querySelectorAll('[data-oa-film]').forEach((film) => {
      if (film.dataset.oaBound) return;
      const video = film.querySelector('video');
      const trigger = film.querySelector('[data-oa-film-play]');
      if (!video || !trigger) return;
      film.dataset.oaBound = 'true';
      trigger.hidden = false;
      trigger.addEventListener('click', async () => {
        trigger.disabled = true;
        try {
          await video.play();
          trigger.hidden = true;
          video.focus();
        } catch {
          trigger.hidden = true;
          video.focus();
        } finally {
          trigger.disabled = false;
        }
      });
      video.addEventListener('ended', () => { trigger.hidden = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindFilms());
  else bindFilms();
  document.addEventListener('shopify:section:load', (event) => bindFilms(event.target));
})();
